import(/* webpackMode: "eager" */ "/opt/build/repo/packages/boat/src/app/account/page.tsx");
